module.exports = __webpack_public_path__ + "static/media/icon-help.6c9156c9.svg";